import { descriptionUI } from 'platform/forms-system/src/js/web-component-patterns';
import FileUploadDescription from '../../components/FormDescriptions/FileUploadDescription';
import {
  attachmentSchema,
  attachmentUI,
  DEFAULT_TITLE_OPTS,
  titleWithNameUI,
} from '../../definitions';
import content from '../../locales/en/content.json';
import { ATTACHMENT_IDS } from '../../utils/constants';

const TITLE_TEXT = content['applicants--birth-certificate-title'];
const DESC_TEXT = content['applicants--birth-certificate-description'];
const INPUT_LABEL = content['applicants--birth-certificate-label'];

export default {
  uiSchema: {
    ...titleWithNameUI(TITLE_TEXT, DESC_TEXT, DEFAULT_TITLE_OPTS.applicant),
    ...descriptionUI(FileUploadDescription),
    applicantBirthCertOrSocialSecCard: attachmentUI({
      title: INPUT_LABEL,
      attachmentId: ATTACHMENT_IDS.birthCert,
    }),
  },
  schema: {
    type: 'object',
    required: ['applicantBirthCertOrSocialSecCard'],
    properties: {
      applicantBirthCertOrSocialSecCard: attachmentSchema,
    },
  },
};
